(ns shared.core.thirdparty.datadog
  (:require [shared.core.config :as config]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            ["@datadog/browser-logs" :as datadog-browser-logs]
            [clojure.string :as s]))

(def datadog? (exists? datadog-browser-logs))

(re/reg-event-db
  :thirdparty/datadog-init re/middleware
  (fn [db [args]]
    (when-not (s/blank? config/DATADOG_CLIENT_TOKEN)
      (datadog-browser-logs/datadogLogs.init
        (-> {:client-token config/DATADOG_CLIENT_TOKEN
             :site "datadoghq.com"
             :env config/ENV
             :version config/VERSION
             :forward-errors-to-logs true
             :sample-rate 100}
            (merge args)
            (util/->camelCaseKeywords)
            (clj->js))))
    db))

(defn ->datadog-args [args]
  (some-> args (util/->camelCaseKeywords) (clj->js)))

(re/reg-event-db
  :thirdparty/datadog-info re/middleware
  (fn [db [msg args]]
    (when datadog?
      (datadog-browser-logs/datadogLogs.logger.info msg (->datadog-args args)))
    db))

(re/reg-event-db
  :thirdparty/datadog-warn re/middleware
  (fn [db [msg args]]
    (when datadog?
      (datadog-browser-logs/datadogLogs.logger.warn msg (->datadog-args args)))
    db))

(re/reg-event-db
  :thirdparty/datadog-error re/middleware
  (fn [db [msg args]]
    (when datadog?
      (datadog-browser-logs/datadogLogs.logger.error msg (->datadog-args args)))
    db))
